<template>
  <div class="accordion__wrapper">
    <div class="accordion__header">
      <button :id="`accordion-button-${id}`" class="accordion__link" :aria-controls="`accordion-content-${id}`" :aria-expanded="active" @click="toggleActive">
            <span class="accordion__title">
              {{ title }}
            </span>
            <span
              class="accordion__toggle"
              :class="{active: active}"
            >
              <img
                class="accordion__toggle-icon"
                :class="{'accordion__toggle-icon--active': active}"
                src="/themes/custom/education_applications_theme/assets/images/icon_plus.svg"
                alt="Expand icon"
              />
              <img
                class="accordion__toggle-icon accordion__toggle-icon--blue"
                :class="{'accordion__toggle-icon--active': active}"
                src="/themes/custom/education_applications_theme/assets/images/icon_plus_blue.svg"
                alt="Expand icon"
              />
            </span>
          </button>
    </div>
    <div :id="`accordion-content-${id}`" class="accordion__content" :class="{'accordion__content--active': active}" :aria-hidden="!active" :aria-labelledby="`accordion-button-${id}`">
      <div class="accordion__content__inner">
        <slot />
        <br />
        <!-- Used line breaks instead of padding for smoother transition -->
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Accordion',
    components: {},
    props: {
      id: {
        type: Number,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      order: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        active: false,
      };
    },
    methods: {
      toggleActive() {
        this.active = !this.active;
      },
    },
  };
</script>

<style scoped lang="scss">
  .accordion {
    &__header {
      font-weight: $font-weight-black !important;
      display: block;
      margin-bottom: 0;
      padding: 0 2rem;
    }
    &__title {
      @include heading-small;
      margin-bottom: 0; // override heading-h4 property
      color: inherit; // override heading-h4 property
      padding-right: 4rem;
      float: left;
      @include education-breakpoint-tablet-down {
        @include heading-x-small;
      }
    }
    &__content {
      border-bottom: 0.5px solid #15171E;
      max-height: 0;
      overflow: hidden;
      padding: 0 2rem;
      &__inner {
        opacity: 0;
        transition: opacity 0.3s;
      }
      &--active {
        /* stylelint-disable-next-line unit-blacklist */
        max-height: 10000px;
        border-bottom: 0.5px solid #15171E;
        .accordion__content__inner {
          opacity: 1;
        }
      }
    }
    &__link {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 1.5rem 0;
      font-size: 0;
      border: none;
      background: transparent;
      position: relative;
      text-align: left;
      outline-width: 0;
      @include outline-width-hidden;
      cursor: pointer;
      &:hover, &:focus, &:active {
        @include outline-width-hidden;
        color: $color-blue;
        .accordion__toggle-icon {
          display: none;
        }
        .accordion__toggle-icon--blue {
          display: inline-block;
        }
      }
    }
    &__toggle {
      font-size: 1rem;
      width: $size-accordion-toggle-width;
      height: $size-accordion-toggle-width;
      position: absolute;
      right: 0;
    }
    &__toggle-icon {
      transition: transform 0.3s;
      &--blue {
        display: none;
      }
      &--active {
        transform: rotate(45deg);
      }
    }
  }
</style>
